const translations: Record<string, string> = {
  "ak_nav_control": "Керування",
  "ak_nav_user": "Користувач",
  "ak_nav_no_energy_storage_at_this_solar_plant": "{{label}} — на цій СЕС накопичувача немає",
  "ak_nav_overview": "Огляд",
  "ak_nav_diagram": "Схема",
  "ak_nav_inverters": "Інвертори",
  "ak_nav_bess": "УЗЕ",
  "ak_nav_equipment_monitoring": "Моніторинг обладнання",
  "ak_nav_fleet_control": "Керування парком",
  "ak_nav_curtailment_sko_dso": "СКО / ОСР",
  "ak_nav_events": "Події",
  "ak_nav_shift_log": "Журнал зміни",
  "ak_nav_telemetry": "Телеметрія",
  "ak_nav_reports": "Звіти",
  "ak_nav_financial_result": "Фінансовий результат",
  "ak_nav_budget": "Бюджет",
  "ak_nav_dispatch_room": "Диспетчерська",
  "ak_nav_forecast": "Прогноз",
  "ak_nav_prices": "Ціни",
  "ak_nav_trading_schedule": "Торговий графік",
  "ak_nav_generation_failed_http": "Не вдалося згенерувати: HTTP {{status}}",
  "ak_nav_export_failed_http": "Експорт не вдався: HTTP {{status}}",
  "ak_nav_generate_monthly_budget": "Згенерувати бюджет місяця ({{stage}})",
  "ak_nav_price_scenario": "Сценарій цін: {{s}}",
  "ak_nav_d": "д",
  "ak_nav_mw": "МВт",
  "ak_nav_trading_schedule_mockup": "Торговий графік (макет)",
  "ak_nav_dam": "РДН",
  "ak_nav_bm_oper": "БР опер.",
  "ak_nav_bm_actual": "БР факт.",
  "ak_nav_today": "Сьогодні",
  "ak_nav_previous_day": "Попередня доба",
  "ak_nav_next_day": "Наступна доба",
  "ak_nav_period_start": "Початок періоду",
  "ak_nav_period_end": "Кінець періоду",
  "ak_nav_previous_period": "Попередній період",
  "ak_nav_next_period": "Наступний період",
  "ak_nav_export_xlsx": "Експорт XLSX",
  "ak_nav_schedule_submission_day": "Доба подачі графіка",
  "ak_nav_previous_month": "Попередній місяць",
  "ak_nav_next_month": "Наступний місяць",
  "ak_nav_delivery_day": "Доба поставки",
  "ak_nav_day": "День",
  "ak_nav_month": "Місяць",
  "ak_nav_period": "Період",
  "ak_nav_chart": "Графік",
  "ak_nav_table": "Таблиця",
  "ak_nav_actual_settlement_enter_the_actual_set": "Факт. розрахунок — внести фактичний розрахунок від Балансуючої групи",
  "ak_nav_analytics_export_ae_xlsx_base_ecmwf_fo": "Аналітичний експорт (AE) — XLSX: прогноз Base/ECMWF, факт, ціни РДН/БР, розряд/заряд УЗЕ за обраний період",
  "ak_nav_draft_t_5_for_approval": "Чернетка T−5 (на узгодження)",
  "ak_nav_final_version_t_1": "Фінальна версія T−1",
  "ak_nav_generate_monthly_budget_2": "Згенерувати бюджет місяця",
  "ak_nav_export_monthly_budget_to_xlsx": "Експорт бюджету місяця у xlsx",
  "ak_nav_export_budget": "Експорт бюджету",
  "ak_nav_failed_to_generate_the_budget": "Не вдалося згенерувати бюджет",
  "ak_nav_export_failed": "Експорт не вдався",
  "ak_nav_draft": "чернетка",
  "ak_nav_final": "фінал",
  "ak_nav_test": "ТЕСТ",
  "ak_nav_test_stand_cabinet2_api_and_database_a": "Тестовий стенд (cabinet2). API та база — спільні з продом.",
};

export default translations;
